<template>
  <div class="ticketBooking">
    <div class="ticketBooking-top">
      <i class="iconfont">&#xe632;</i>报名详情
    </div>
    <div class="ticketBookingBox">
      <div class="registrationDetails-top">
        <div class="topLeft">{{detail.activityName}}</div>
        <div class="topRight"></div>
      </div>
      <div class="registrationDetails-bottom">
        <div class="boxTop-lefts">
          积分：
          <span class="integral">{{detail.scoreNum}}</span>
        </div>
        <div class="ticketBookingBox-boxTops">
          <span class="text">
            <i class="iconfont">&#xe607;</i>
            参观日期：{{formatTime(detail.activityStaTime)}} {{getTime(detail.activityStaTime)}} - {{getTime(detail.activityEndTime)}}
          </span>
          <span
            class="boxBottom-text3"
            v-touch:tap="gotoQRCodeVolunteer( detail.activityId, detail.volunteerId )"
          >
            <i class="iconhebei iconerweima"></i>电子二维码
          </span>
        </div>
      </div>
      <div class="registrationDetails-top">
        <div class="topLeft">{{detail.title}}</div>
        <template v-if="detail.entryStatus	==1">
          <div class="topRights">预约成功</div>
        </template>
        <template v-else>
          <div class="topRights">已取消</div>
        </template>
      </div>
      <div class="registrationDetails-bottom">
        <div class="bottom-text">联 系 人：{{detail.userName}}</div>
        <div class="bottom-text">手 机 号：{{detail.phone}}</div>
        <div class="bottom-text">身份证号：{{detail.idcard}}</div>
        <div class="bottom-text">预约时间：{{detail.entryTime}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@js/http-zyz.js";
import { entryDetail } from "@js/volunteerUrl";
import util from "@util";

export default {
  data() {
    return {
      detail: {}
    };
  },
  computed: {
    openId() {
      return this.$store.state.userInfo.openId;
    }
  },
  created() {
    let { activityId, volunteerId } = this.$route.query;
    this.getDetail(activityId, volunteerId);
  },
  methods: {
    getDetail(activityId, volunteerId) {
      http
        .post(entryDetail, {
          activityId,
          volunteerId,
          openId: this.openId
        })
        .then(res => {
          res.data.data.activityStaTime = res.data.data.activityStaTime.replace(/-/g,'/')
          res.data.data.activityEndTime = res.data.data.activityEndTime.replace(/-/g,'/')
          this.detail = res.data.data;
        });
    },
    //电子二维码
    gotoQRCodeVolunteer(activityId, volunteerId) {
      return () => {
        this.$router
          .push({
            path: "qrcodev",
            query: { activityId, volunteerId }
          })
          .catch(err => {
            err;
          });
      };
    },
    formatTime(time) {
      return util.formatTime(new Date(time), "yyyy-MM-dd");
    },
    getTime(item) {
      return util.getTime(item);
    }
  }
};
</script>

<style lang="less" scoped>
.ticketBooking {
  background-color: #f1effb !important;
  padding: 20px 7px;
  .iconhebei {
    display: inline-block;
    transform: translateY(2px);
    margin-right: 2px;
  }
  .ticketBooking-top {
    padding: 0 17px;
    color: #606060;
    font-size: 14px;
    line-height: 20px;
    .iconfont {
      color: #5a9bf6;
      padding-right: 6px;
      font-size: 18px;
    }
  }
  .ticketBookingBox {
    margin-top: 13px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    padding: 0 8px;
    .registrationDetails-top {
      overflow: auto;
      zoom: 1;
      padding: 10px;
      border-bottom: 0.5px solid #d8d8d8;
      .topLeft {
        float: left;
        color: #606060;
        font-size: 14px;
      }
      .topRight {
        float: right;
        color: #ff9e15;
        font-size: 14px;
      }
      .topRights {
        float: right;
        color: #27af2d;
        font-size: 14px;
      }
    }
    .registrationDetails-bottom {
      padding: 10px;
      .boxTop-lefts {
        line-height: 20px;
        font-size: 14px;
        color: #b3b3b3;
        font-weight: 500;
        .integral {
          color: #ff8d09;
          font-size: 14px;
          font-weight: 500;
        }
      }
      .ticketBookingBox-boxTops {
        // display: -webkit-flex;
        // display: flex;
        margin-top: 20px;
        .text {
          color: #606060;
          font-size: 12px;
          line-height: 20px;
          // float: left;
        }
        .iconfont {
          color: #5a9bf6;
        }
        .boxBottom-text3 {
          color: #606060;
          font-size: 12px;
          padding-left: 15px;
          // text-align: right;
          line-height: 20px;
          .iconfont {
            padding-right: 6px;
          }
        }
      }
      .bottom-text {
        color: #8c8c8c;
        font-size: 14px;
        line-height: 20px;
        margin: 6px 0;
      }
    }
  }
}
</style>